import React, { useEffect, useState } from 'react';
import { ButtonLink } from '@kyruus/button';
import { FormattedMessage } from '@kyruus/intl';

import { SortFilterLocations } from './styles';
import { FacetPanel } from '../../../search-v9/facet-panel';
import SideSheet from '../SideSheet';

import { SORT_AND_FILTER_DRAWER_OPEN } from '../../../machines/map-search-v9/map-search-states';
import { CLOSE_SORT_AND_FILTER } from '../../../machines/map-search-v9/map-search-actions';
import SortFilterErrorBanner from './sort-filter-error-banner';
import { useKeydownListener } from '../../../utils/hooks';

function SortFilterPanel({
  messages,
  state,
  send,
  log,
  getUpdatedLocations,
  config,
  history,
  isScreenMediumOrBelow,
  configuredFacets
}) {
  const [isOpen, setIsOpen] = useState(false);

  const hasFilterApplied = configuredFacets.find((facet) => {
    return facet.terms.some((t) => t.applied);
  });

  const { searchParams, providers } = state.context;

  const onCloseSortAndFilterButtonClick = () => {
    send(CLOSE_SORT_AND_FILTER);
  };

  // close panel on escape key
  useKeydownListener('Escape', () => {
    if (state.matches(`${SORT_AND_FILTER_DRAWER_OPEN}`)) {
      onCloseSortAndFilterButtonClick();
    }
  });

  const renderCloseLink = (btnTextId) => {
    return (
      <ButtonLink
        mode="flat"
        onClick={(e) => {
          e.preventDefault();
          onCloseSortAndFilterButtonClick();
        }}
        className="closeBtn"
      >
        <FormattedMessage {...btnTextId} />
      </ButtonLink>
    );
  };

  useEffect(() => {
    if (state.matches(SORT_AND_FILTER_DRAWER_OPEN)) {
      setIsOpen(state.matches(SORT_AND_FILTER_DRAWER_OPEN));
    }
  }, [state]);

  return (
    <SideSheet
      dataTestId="SideSheetSortFilter"
      anchor="right"
      width={isScreenMediumOrBelow ? '100vw' : '20vw'}
      // 260px value comes from design here: https://kyruus.jira.com/browse/KENG-29422?focusedCommentId=255698
      minWidth="260px"
      isOpen={isOpen}
      closeDrawer={onCloseSortAndFilterButtonClick}
    >
      <React.Fragment>
        {configuredFacets.length ? (
          <SortFilterLocations>
            <FacetPanel
              showMobileFacets={true}
              searchSummary={{
                has_filters: hasFilterApplied && hasFilterApplied.terms.length,
                sort: searchParams.sort
              }}
              totalProviders={providers.total_providers}
              log={log}
              getUpdatedSearch={getUpdatedLocations}
              toggleMobileFacets={onCloseSortAndFilterButtonClick}
              facets={configuredFacets}
              showLocationFacet={false}
              config={config}
              history={history}
            />
          </SortFilterLocations>
        ) : (
          // show error banner when facet length is 0
          <SortFilterErrorBanner
            messages={messages}
            renderCloseLink={renderCloseLink}
            log={log}
          />
        )}
      </React.Fragment>
    </SideSheet>
  );
}

export default SortFilterPanel;
